module.exports = __webpack_public_path__ + "img/default-avator.2c3dc042.svg";